import { render, staticRenderFns } from "./mobanXz.vue?vue&type=template&id=f80efb82&scoped=true"
import script from "./mobanXz.vue?vue&type=script&lang=js"
export * from "./mobanXz.vue?vue&type=script&lang=js"
import style0 from "./mobanXz.vue?vue&type=style&index=0&id=f80efb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80efb82",
  null
  
)

export default component.exports